import { render } from "./VPersonify.vue?vue&type=template&id=3b31ad54"
import script from "./VPersonify.vue?vue&type=script&lang=js"
export * from "./VPersonify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__